/* eslint-disable import/prefer-default-export */
import { inject } from 'vue';

import {
  ColorsType,
  ColorManagerType,
} from '@constants/colors';

type UseColorType = { colors: ColorsType, colorManager: ColorManagerType };
type UseColorFunctionType = () => UseColorType;

export const useColor: UseColorFunctionType = () => {
  const colors = inject<ColorsType>('$colors');
  const colorManager = inject<ColorManagerType>('$colorManager');
  return { colors, colorManager } as UseColorType;
};
